import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AdminView from '../views/AdminView.vue'; // 新增
import ContractManagement from '../views/ContractManagement.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue';
import PCTManagementView from '../views/PCTManagementView.vue';
import PCDManagementView from '../views/PCDManagementView.vue';

const routes = [
  { path: '/wallet/legacy', name: 'legacy-rights', component: () => import('../views/LegacyRightsView.vue'), meta: { forest: true, section: 'wallet' } },
  { path: '/wallet/nfts', name: 'nft-gallery', component: () => import('../views/NftGalleryView.vue'), meta: { forest: true, section: 'wallet' } },
  { path: '/nft/:collection/:tokenId', name: 'nft-detail', component: () => import('../views/NftDetailView.vue'), meta: { forest: true, section: 'wallet' } },
  { path: '/ecosystem', name: 'ecosystem', component: () => import('../views/EcosystemView.vue'), meta: { forest: true, section: 'ecosystem' } },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { keepAlive: true }
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/InviteView.vue') // 邀請頁面路由
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView // 新增
  },
  {
    path: '/management',
    name: 'contract-management',
    component: ContractManagement
  },
  {
    path: '/mine',
    name: 'mining',
    component: () => import('../views/MiningView.vue') // 挖礦頁面路由
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('../views/WalletView.vue') // 錢包頁面路由
  },
  {
    path: '/buy-pine',
    name: 'buy-pine',
    component: () => import('../views/BuyPineView.vue')
  },
  {
    path: '/admin-dashboard',
    name: 'admin-dashboard',
    component: AdminDashboardView
  },
  {
    path: '/admin/pct',
    name: 'pct-management',
    component: PCTManagementView
  },
  {
    path: '/admin/pcd',
    name: 'pcd-management',
    component: PCDManagementView
  },
  {
    path: '/admin/xpct',
    name: 'xpct-management',
    component: () => import('../views/AdminXpctManage.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
